import { render, staticRenderFns } from "./AdminPanelLogs.vue?vue&type=template&id=11727bf0&"
import script from "./AdminPanelLogs.vue?vue&type=script&lang=js&"
export * from "./AdminPanelLogs.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanelLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
